import Breadcrumbs, { BreadcrumbSection } from '../../components/breadcrumbs/Breadcrumbs';
import { useEffect, useState } from 'react';
import { FilePath, PathNode } from '../../types/file-record';
import { HomeIcon } from '@heroicons/react/24/solid';
import { useFirmContext } from '../../providers/FirmProvider';
import { useDispatch, useSelector } from 'react-redux';
import { selector, setPath } from '../../slices/filesSlice';

type FileBreadcrumbsProps = {
    path: PathNode[];
    onLevelSelect: (value: string) => void;
    size?: 'small' | 'regular';
    disableCurrentLevel?: boolean;
    sync?: boolean;
};

function FilesBreadcrumbs({
    path,
    onLevelSelect,
    size = 'regular',
    disableCurrentLevel = true,
    sync = false,
}: FileBreadcrumbsProps): JSX.Element {
    const { id: firmId } = useFirmContext();
    const [sections, setSections] = useState<BreadcrumbSection[]>(formatSections(path, firmId, size, disableCurrentLevel));
    const dispatch = useDispatch();
    const { currentPath } = useSelector(selector);

    useEffect(() => {
        setSections(formatSections(path, firmId, size, disableCurrentLevel));
    }, [path, firmId, size, disableCurrentLevel]);

    useEffect(() => {
        if (JSON.stringify(path) !== JSON.stringify(currentPath) && sync) {
            dispatch(setPath(path));
        }
    }, [currentPath, dispatch, path, sync]);

    return (
        <div className={`${size === 'regular' ? 'pb-2 border-b ' : ''}`}>
            <Breadcrumbs sections={sections} onClick={onLevelSelect} size={size} />
        </div>
    );
}

function formatSections(
    path: PathNode[],
    firmId: string,
    size: 'regular' | 'small' = 'regular',
    disableCurrentLevel = true
): BreadcrumbSection[] {
    const sorted = [...path].sort((a, b) => (a.level > b.level ? 1 : -1));

    const sections: BreadcrumbSection[] = [];

    sorted.forEach((item) => {
        // const section: BreadcrumbSection = [];
        // item.folders.forEach((folder) => {
        //     section.push({
        //         label: folder.id === firmId ? <HomeIcon className={`${size === 'regular' ? 'h-5 w-5' : 'h-4 w-4'}`} /> : folder.name,
        //         value: folder.id,
        //         selected: disableCurrentLevel && item.level === 0,
        //     });
        // });
        const section = {
            label: item.id === firmId ? <HomeIcon className={`${size === 'regular' ? 'h-5 w-5' : 'h-4 w-4'}`} /> : item.name,
            value: item.id,
            selected: disableCurrentLevel && item.level === path.length,
            locked: item.locked,
        };
        sections.push(section);
    });

    return sections;
}

export default FilesBreadcrumbs;
